import React, { useEffect, useState } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Mission } from './components/Mission';
import { CommunityStrength } from './components/CommunityStrength';
import { Leadership } from './components/Leadership';
import { AdvisoryCouncil } from './components/AdvisoryCouncil';
import { NewsBlog } from './components/NewsBlog';
import { NonprofitScroller } from './components/NonprofitScroller';
import { HondurasFacts } from './components/HondurasFacts';
import { MediaScroller } from './components/MediaScroller';
import { ConsularAffairs } from './components/ConsularAffairs';
import { BusinessInvestments } from './components/BusinessInvestments';
import { NonprofitDirectory } from './components/NonprofitDirectory';
import { ExploreHonduras } from './components/ExploreHonduras';
import { HondurasQuiz } from './components/HondurasQuiz';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { Events } from './components/Events';
import { ConsularBanner } from './components/ConsularBanner';
import { LandingPage } from './components/LandingPage';
import { SocialMediaVoices } from './components/SocialMediaVoices';
import { AdminDashboard } from './components/AdminDashboard';
import { useLanguage } from './contexts/LanguageContext';
import { FeedbackPopup } from './components/FeedbackPopup';
import { ConsularPage } from './pages/ConsularPage';
import { BusinessMapPage } from './pages/BusinessMapPage';
function AppContent({
  showLanding,
  setShowLanding
}: {
  showLanding: boolean;
  setShowLanding: (v: boolean) => void;
}) {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [pendingScroll, setPendingScroll] = useState<string | null>(null);
  const handleSelectLanguage = (lang: 'EN' | 'ES') => {
    setLanguage(lang);
    setShowLanding(false);
  };
  const handleConsularAccess = (lang: 'EN' | 'ES') => {
    setLanguage(lang);
    setShowLanding(false);
    setPendingScroll('consular-affairs');
  };
  useEffect(() => {
    if (!showLanding && pendingScroll) {
      const timer = setTimeout(() => {
        const el = document.getElementById(pendingScroll);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
        setPendingScroll(null);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [showLanding, pendingScroll]);
  if (showLanding) {
    return <LandingPage onSelectLanguage={handleSelectLanguage} onConsularAccess={handleConsularAccess} data-id="element-0" />;
  }
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-1">
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ConsularBanner data-id="element-5" />
        <Mission data-id="element-6" />
        <NonprofitScroller data-id="element-7" />
        <CommunityStrength data-id="element-8" />
        <NewsBlog data-id="element-9" />
        <MediaScroller data-id="element-10" />
        <Leadership data-id="element-11" />
        <AdvisoryCouncil data-id="element-12" />
        <ConsularAffairs data-id="element-13" />
        <BusinessInvestments data-id="element-14" />
        <HondurasQuiz data-id="element-15" />
        <ExploreHonduras data-id="element-16" />
        <SocialMediaVoices data-id="element-17" />
        <NonprofitDirectory data-id="element-18" />
        <FAQ data-id="element-19" />
      </main>
      <Footer data-id="element-20" />
      <FeedbackPopup data-id="element-21" />
    </div>;
}
export function App() {
  const [showLanding, setShowLanding] = useState(true);
  const [showAdmin, setShowAdmin] = useState(() => window.location.hash === '#/admin');
  const [showConsular, setShowConsular] = useState(() => window.location.hash === '#/consular');
  const [showBusinessMap, setShowBusinessMap] = useState(() => window.location.hash === '#/business-map');
  useEffect(() => {
    const handleHash = () => {
      setShowAdmin(window.location.hash === '#/admin');
      setShowConsular(window.location.hash === '#/consular');
      setShowBusinessMap(window.location.hash === '#/business-map');
    };
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);
  const handleReturnToLanding = () => {
    setShowLanding(true);
  };
  if (showAdmin) {
    return <AdminDashboard onBack={() => {
      window.location.hash = '';
      setShowAdmin(false);
    }} data-id="element-22" />;
  }
  if (showConsular) {
    return <LanguageProvider onLanguageSwitch={handleReturnToLanding} data-id="element-23">
        <ConsularPage data-id="element-24" />
      </LanguageProvider>;
  }
  if (showBusinessMap) {
    return <LanguageProvider onLanguageSwitch={handleReturnToLanding} data-id="element-25">
        <BusinessMapPage data-id="element-26" />
      </LanguageProvider>;
  }
  return <LanguageProvider onLanguageSwitch={handleReturnToLanding} data-id="element-27">
      <AppContent showLanding={showLanding} setShowLanding={setShowLanding} data-id="element-28" />
    </LanguageProvider>;
}